<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-title">
        <h4>Update Estimate Time Setting</h4>
      </div>
      <div class="grid-body">
        <div class="row flex">
          <div class="col-md-4">
            <h5>AREA</h5>
            <v-select
              placeholder="SELECT AREA"
              v-model="shirtOrderStatusId"
              :options="areas"
              @input="changeArea"
              :reduce="(areas) => areas.id"
            />
          </div>
          <div class="col-md-4" v-if="shirtOrderStatusId != null">
            <h5>STATION</h5>
            <v-select
              placeholder="SELECT STATION"
              v-model="stationId"
              :options="stations"
              label="name"
              @input="changeStation"
              :reduce="(stations) => stations.id"
            />
          </div>
          <div class="col-md-4 text-right text-align-bottom">
            <router-link
              class="btn btn-success"
              :to="{ path: '/performance_tracking/fabric_category_matchings' }"
            >
              Edit Fabric Category Matching
            </router-link>
          </div>
        </div>
        <br />

        <div class="alert alert-danger" v-if="error">
          <strong>{{ error }}</strong>
        </div>

        <table class="table table-bordered" v-if="stationId">
          <thead>
            <tr>
              <th class="text-center">#</th>
              <th class="text-center">Type</th>
              <th class="text-center">Style</th>
              <th class="text-center">Category 1</th>
              <th class="text-center">Category 2</th>
              <th class="text-center">Category 3</th>
              <th class="text-center">Category 4</th>
              <th class="text-center">Category 5</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(setting, index) in settings">
              <td>{{ index + 1 }}</td>
              <td class="text-center">
                <select class="form-control" v-model="setting.type">
                  <option value="female">Woman</option>
                  <option value="male">Man</option>
                  <option value="lady">Lady</option>
                </select>
              </td>
              <td class="text-center">
                <input type="number" v-model="setting.style" />
              </td>
              <td class="text-center">
                <input type="time" v-model="setting.category_1" />
              </td>
              <td class="text-center">
                <input type="time" v-model="setting.category_2" />
              </td>
              <td class="text-center">
                <input type="time" v-model="setting.category_3" />
              </td>
              <td class="text-center">
                <input type="time" v-model="setting.category_4" />
              </td>
              <td class="text-center">
                <input type="time" v-model="setting.category_5" />
              </td>
              <td>
                <button class="btn btn-danger" @click="deleteSetting(index)">
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
            <tr>
              <td colspan="9">
                <button class="btn btn-success btn-xs" @click="addRow()">
                  <i class="fa fa-plus-circle" aria-hidden="true"></i> Add Row
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <button
          v-if="stationId"
          class="btn btn-block btn-primary"
          @click="saveData()"
        >
          UPDATE SETTING
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import AreaStatusMatching from "./tools/AreaStatusMatching.json";
import vSelect from "vue-select";
import _ from "lodash";
import alasql from "alasql";

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      areas: [],
      shirtOrderStatusId: null,
      stationId: null,
      stations: [],
      settings: [],
      error: null,
    };
  },
  mounted() {
    this.getAreas();
  },
  methods: {
    getAreas() {
      let data = AreaStatusMatching.en;
      data.forEach((val) => {
        this.areas.push(val);
      });
    },
    async getStations() {
      let res = await axios.get(
        "performance_tracking/station/listings/" + this.shirtOrderStatusId
      );
      this.stations = res.data;
    },

    changeArea() {
      this.settings = [];
      this.stationId = null;
      if (this.shirtOrderStatusId == null) {
        this.stations = [];
      } else this.getStations();
    },
    changeStation() {
      this.getEstTimeSettings();
    },
    async getEstTimeSettings() {
      let res = await axios.get(
        "performance_tracking/estimate_time_settings/" + this.stationId
      );
      this.settings = res.data;
    },
    addRow() {
      this.settings.push({
        type: "male",
        style: null,
        category_1: "00:00",
        category_2: "00:00",
        category_3: "00:00",
        category_4: "00:00",
        category_5: "00:00",
      });
    },
    async saveData() {
      let data = this.settings;
      var check = alasql(
        "SELECT count(*) as total ,type , style FROM ? GROUP BY type, style",
        [data]
      );
      var check = alasql("SELECT count(*) as total FROM ? where total > 1", [
        check,
      ]);
      if (check[0].total > 0) {
        this.error = "Duplicate Type with Style Found, Please Check!";
      } else if (this.shirtOrderStatusId == null) {
        this.error = "PLease Select Area";
      } else if (this.stationId == null) {
        this.error = "Please Select Station";
      } else {
        this.error = null;
        try {
          let res = await axios.put(
            "performance_tracking/estimate_time_settings/update",
            {
              settings: data,
              shirt_order_status_id: this.shirtOrderStatusId,
              station_id: this.stationId,
            }
          );
          Swal.fire("SUCCESS", "Successfully Updated!", "success");
        } catch (err) {
          this.error = "Something Wrong Please Try Again";
        }
      }
    },
    deleteSetting(index) {
      this.settings.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.text-align-bottom {
  align-self: flex-end;
}
.flex {
  display: flex;
}
</style>
